export default {
    fund: 'Cuenta de caja',
    name: 'Nombre',
    type: {
        title: 'Tipo',
        main: 'Principal',
        sub: 'Sub',
    },
    category: 'Clasificación',
    'final-account': {
        title: 'Cuenta final',
        operations: 'Explotación',
        trade: 'Mercancía',
        'gains-and-losses': 'Cuenta de pérdidas y ganancias',
        budget: 'Balance general',
    },

    set: 'Fijar',
    reset: 'Restablecer',
    account: 'Cuenta',
    save: 'Guardar',

    'default-warehouse': 'Almacén predeterminado',
    no: 'Id',
    notes: 'Notas',
    warehouse: 'Almacén',
    
    'purchasing-account': 'Cuenta de compras',
    'purchasing-refund-account': 'Cuenta de reembolso de compra',
    'account-trade': 'Cuenta (mercancía)',
    
    'sales-account': 'Cuenta de venta',
    'sales-refund-account': 'Cuenta de reembolso de venta',
    
    'granted-discount-account': 'Cuenta de descuento otorgado',
    'account-gains-and-losses-or-trade': 'Cuenta(pérdidas y ganancias-mercancía)',
    'account-budget': 'Cuenta (balance general)',

    'earned-discount-account': 'Cuenta de descuento ganado',

    'rotate-profit-and-loss': 'Cuenta rotativa de pérdidas y ganancias',
    'rotate-materials-end-of-term': 'Cuenta de inventario final',
}